import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { revenueCategoryApi } from '../services/accountingApi';

export const REVENUE_CATEGORY_RULES_KEY = 'accounting-revenue-category-rules';

export function useRevenueCategoryRules(params?: { entity_type?: string; account_id?: string }) {
  return useQuery({
    queryKey: [REVENUE_CATEGORY_RULES_KEY, params],
    queryFn: () => revenueCategoryApi.list(params),
  });
}

export function useCreateRevenueCategoryRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { account_id: string; entity_type: string; entity_id: string }) =>
      revenueCategoryApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REVENUE_CATEGORY_RULES_KEY] });
    },
  });
}

export function useBulkUpsertRevenueCategoryRules() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { account_id: string; entity_type: string; entity_ids: string[] }) =>
      revenueCategoryApi.bulkUpsert(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REVENUE_CATEGORY_RULES_KEY] });
    },
  });
}

export function useDeleteRevenueCategoryRule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ruleId: string) => revenueCategoryApi.delete(ruleId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [REVENUE_CATEGORY_RULES_KEY] });
    },
  });
}

export function useResolveRevenueAccount() {
  return useMutation({
    mutationFn: (data: {
      product_id?: string;
      product_category_id?: string;
      invoice_level_account_id?: string;
      customer_id?: string;
    }) => revenueCategoryApi.resolve(data),
  });
}
